import { sortAlphabeticallyByKey } from '@fortem-monorepo/js-utilities'

export const FUNDING_INSTRUMENTS = ['SONIO/N Index', 'SOFRRATE Index'] as const

export type FundingInstrument = (typeof FUNDING_INSTRUMENTS)[number]

export const FUNDING_INSTRUENT_LABELS: Record<FundingInstrument, string> = {
  'SONIO/N Index': 'SONIO/N Index',
  'SOFRRATE Index': 'SOFRRATE Index',
}

export const FUNDING_INSTRUMENT_OPTIONS = sortAlphabeticallyByKey(
  FUNDING_INSTRUMENTS.map((i) => ({
    label: i,
    value: i,
  })),
  'label',
)
